module.exports = __webpack_public_path__ + "static/image1-411a0e07b90cea5b3db3870340f23df5.jpg";